import { gql } from '@apollo/client'

export const ADD_AUDIENCE_ELIGIBILITY = gql`
    query AddAudienceEligibility($adCampaignId: String!, $publisherId: String!) {
        AudienceHypothesis {
            addAudienceEligibility(adCampaignId: $adCampaignId, publisherId: $publisherId) {
                eligible
                reason
                message
                max_ad_sets
                existing_ad_set_count
                available_ad_set_slots
                max_personas
                min_daily_budget
                total_budget
                currency
                donors {
                    ad_set_id
                    name
                    budget
                    max_movable
                    learning_status
                    delivery_status
                    usable
                    message
                }
                unfinished_ad_sets {
                    ad_set_id
                    name
                    budget
                }
            }
        }
    }
`

/** Removes unpublished ad sets of a budget move that did not finish; ad sets published meanwhile are left and named. */
export const REMOVE_UNFINISHED_AD_SETS = gql`
    mutation RemoveUnfinishedAdSets($adCampaignId: String!, $adSetIds: [String!]!) {
        removeUnfinishedAdSets(adCampaignId: $adCampaignId, adSetIds: $adSetIds) {
            removed {
                ad_set_id
                name
            }
            kept {
                ad_set_id
                name
                reason
            }
            message
        }
    }
`

/** AI audiences for an existing ad campaign: the acquisition budget is the amount moved from the donor ad set. */
export const GENERATE_ADD_AUDIENCE_HYPOTHESES = gql`
    mutation GenerateAddAudienceHypotheses(
        $campaignId: String!
        $publisherId: String!
        $objective: CampaignObjective!
        $location: LocationTargeting!
        $acquisitionBudget: Float!
        $requestedPersonas: Int
        $regenerate: Boolean
        $adCampaignId: String!
        $donorAdSetId: String!
    ) {
        generateAudienceHypotheses(
            campaignId: $campaignId
            publisherId: $publisherId
            objective: $objective
            location: $location
            acquisitionBudget: $acquisitionBudget
            requestedPersonas: $requestedPersonas
            regenerate: $regenerate
            adCampaignId: $adCampaignId
            donorAdSetId: $donorAdSetId
        ) {
            hypothesis_set_id
            status
            reason
            cached
            discarded_persona_count
            plan {
                persona_count
                recommended_persona_count
                ad_set_count
                reason
                warnings
                required_per_ad_set
                budget_per_ad_set
                personas_allowed
                mode
            }
            hypotheses {
                id
                kind
                label
                audience_id
                audience_mode
                status
                intent
                rationale
                problem
                outcome
                interests {
                    id
                    name
                }
                targeting_options {
                    option_class
                    id
                    name
                }
                estimated_reach_lower
                estimated_reach_upper
                discarded_term_count
                unavailable_term_count
                validated_at
                recommended
            }
        }
    }
`
